import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelpLinkReq, HelpLinkRes } from '../models/HelpLinkReq';

@Injectable({
  providedIn: 'root'
})
export class HelplinkService {
  private apiUrl: string = environment.apiUrl ;
  constructor(private http: HttpClient) { }

  saveHelpLinkDetails(request:HelpLinkReq):Observable<HelpLinkRes>
  {
    const url = this.apiUrl + 'api/help';//Need to put url    
    return this.http.post<HelpLinkRes>(url, request);
  }

  sendEmail(request:HelpLinkReq):Observable<void>
  {
    const url = this.apiUrl + 'api/email';//Need to put url    
    return this.http.post<void>(url, request);
  }
}
